module.exports = __webpack_public_path__ + "img/swiperItem1.cd74616e.png";